import { createSelector } from 'reselect';
import { getBoughtInStore } from './get-bought-in-store';
import { isBoughtInStoreSuccessfullyLoaded } from '.';

const EMPTY_BOUGHT_IN_STORE_PRODUCTS_ARRAY: never[] = [];

export const getBoughtInStoreProducts = createSelector([getBoughtInStore], boughtInStore =>
  isBoughtInStoreSuccessfullyLoaded(boughtInStore)
    ? boughtInStore.componentsAndProducts
    : EMPTY_BOUGHT_IN_STORE_PRODUCTS_ARRAY,
);

export const getBoughtInStoreProductsLength = createSelector(
  [getBoughtInStoreProducts],
  products => products.length,
);
